module.exports = __webpack_public_path__ + "img/whats-new-mobile_cn.864a38e.jpg";